let version = {};

version.init = async () => {
  try {
    let NxVetVersion = window.storage.get("NxVet-Version");

    if (!NxVetVersion) {
      const res = await window.NxVetV2.getVersion();
      window.storage.set("NxVet-Version", res.Version);
    }
  } catch (error) {
    window.location.href = "/app";
  }
};

version.askRefresh = async () => {
  try {
    let localVersion = window.storage.get("NxVet-Version");
    let res = await window.NxVetV2.getVersion();
    let remoteVersion = res.Version;

    if (localVersion == remoteVersion) {
      console.log("askRefresh: same version", localVersion);
      return;
    }

    window.storage.set("NxVet-Version", remoteVersion);

    window.VueApp.$confirm("應用程式已經更新，是否立即重整網頁？", {
      closeOnClickModal: false,
      closeOnPressEscape: false,
      closeOnHashChange: false,
      customClass: "update-version-modal",
    })
      .then(async (_) => {
        window.location.href = "/app";
      })
      .catch((_) => {});
  } catch (error) {
    window.location.href = "/app";
  }
};

version.forceUpdate = () => {
  try {
    window.VueApp.$alert("應用程式已經更新，請立即重整網頁。", "更新通知", {
      confirmButtonText: "確定",
      customClass: "update-version-modal",
      callback: async (action) => {
        const res = await window.NxVetV2.getVersion();
        window.storage.set("NxVet-Version", res.Version);
        window.location.href = "/app";
      },
    });
  } catch (error) {
    window.location.href = "/app";
  }
};

export default version;
